import { render, staticRenderFns } from "./AuthTree.vue?vue&type=template&id=2c96a8dd&scoped=true&"
import script from "./AuthTree.vue?vue&type=script&lang=js&"
export * from "./AuthTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96a8dd",
  null
  
)

export default component.exports